import { cx } from '@linaria/core';

import { Loader } from '~shared/ui/atoms/Loader';

import { Button, Content, StyledLink } from './styles';

export type ActionFlatProps = {
	form?: string;
	type?: 'button' | 'submit' | 'reset';
	children?: React.ReactNode;
	className?: string;
	text?: React.ReactNode;
	icon?: React.ReactNode;
	fullWidth?: boolean;
	disabled?: boolean;
	loading?: boolean;
	href?: string;
	onClick?: () => void;
};

export const ActionFlat = ({
	form,
	type = 'button',
	children,
	className,
	text,
	icon,
	fullWidth,
	disabled,
	loading,
	href,
	onClick,
}: ActionFlatProps) => {
	const inner = (
		<>
			{loading && <Loader size={19} plane={true} />}
			<Content hidden={loading}>
				{icon}
				{text}
				{children}
			</Content>
		</>
	);

	const actionClassName = cx(
		loading && 'action_loading',
		fullWidth && 'action_fullWidth',
		className
	);

	return href ? (
		<StyledLink className={actionClassName} href={href}>
			{inner}
		</StyledLink>
	) : (
		<Button
			form={form}
			type={type}
			className={actionClassName}
			disabled={disabled}
			onClick={onClick}
		>
			{inner}
		</Button>
	);
};
